export default "__VITE_ASSET__5C8CYnBe__"